export const services = [
  {
    slug: "civil-work",
    title: "Civil Work",
    tagline:
      "Professional civil construction and execution including masonry, plastering, flooring and related civil work.",
    image:
      "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?auto=format&fit=crop&w=1800&q=80",
    alt: "Professional civil construction and concrete work in Mumbai by Saurabh Decor Creations",
    intro: [
      "Strong civil work is the foundation of every well-built space. Saurabh Decor Creations handles civil execution with careful planning, the right materials and professional on-site workmanship — so everything built on top of it lasts.",
      "From masonry and plastering to flooring and structural repairs, we manage civil work for homes, offices and commercial spaces across Mumbai with clear coordination at every stage.",
    ],
    includes: [
      "Masonry & Brickwork",
      "Plastering & Surface Finishing",
      "Flooring & Tiling",
      "Waterproofing & Damp Treatment",
      "Demolition & Site Preparation",
      "Structural Repairs",
    ],
  },
  {
    slug: "interior-work",
    title: "Interior Work",
    tagline:
      "Modern interior execution focused on functionality, quality finishing and elegant design.",
    image:
      "https://images.unsplash.com/photo-1601993957728-1e56ab70c5a8?auto=format&fit=crop&w=1800&q=80",
    alt: "Modern minimalist interior work executed in a Mumbai residence",
    intro: [
      "Good interiors balance how a space looks with how it works every day. We execute modern interiors for homes and commercial spaces with attention to finishing, proportions and practical use of every square foot.",
      "From false ceilings and lighting to custom furniture and final paint, every stage is planned and executed with precision so the finished space feels considered, not assembled.",
    ],
    includes: [
      "Complete Home Interiors",
      "False Ceilings & Lighting",
      "Painting & Wall Finishes",
      "Custom Furniture & Carpentry",
      "Electrical & Fixture Coordination",
      "Office & Commercial Interiors",
    ],
  },
  {
    slug: "modular-kitchen",
    title: "Modular Kitchen",
    tagline:
      "Contemporary modular kitchens with smart storage, practical layouts, quality finishes and professional installation.",
    image:
      "https://images.unsplash.com/photo-1663811396777-05505d999151?auto=format&fit=crop&w=1800&q=80",
    alt: "Contemporary modular kitchen with smart storage installed in Mumbai",
    intro: [
      "A kitchen should work as beautifully as it looks. We design and install contemporary modular kitchens built around your space, your cooking habits and your storage needs — with quality materials and hardware throughout.",
      "From layout planning and smart storage to countertops, fittings and final installation, we handle the complete kitchen journey with careful finishing at every step.",
    ],
    includes: [
      "Layout Planning — L-Shape, U-Shape, Parallel, Island",
      "Smart Storage Solutions",
      "Countertops & Backsplashes",
      "Quality Hardware & Fittings",
      "Appliance Integration",
      "Professional Installation & Finishing",
    ],
  },
  {
    slug: "restoration-renovation",
    title: "Restoration & Renovation",
    tagline:
      "Renovation, restoration, repair and modernization of existing homes and spaces.",
    image:
      "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?auto=format&fit=crop&w=1800&q=80",
    alt: "Restored and renovated premium living room in a Mumbai home",
    intro: [
      "Older spaces carry value — they just need the right hands. We renovate, restore and modernize existing homes and commercial spaces, upgrading them to current standards of comfort, finish and functionality.",
      "Whether it is a full home renovation, a kitchen and bathroom upgrade, or careful repair and restoration work, we plan the project around your space, budget and timeline.",
    ],
    includes: [
      "Full Home Renovation",
      "Kitchen & Bathroom Upgrades",
      "Repairs & Restoration",
      "Repainting & Refinishing",
      "Space Re-planning & Modernization",
      "Office Renovation",
    ],
  },
];
